<template>
<v-flex v-bind:class="classes" >
<v-combobox
      v-model="selected"
      :label="label"
      :loading="loading"
      :required="required"
      hide-selected
      :items="items"
      :search-input.sync="search"
      :error-messages="errorMessages"
      :item-text="from"
      multiple
      small-chips
    >
    <template
          slot="selection"
          slot-scope="{ item, selected }"
        >
          <v-chip
            small
            close
            :selected="selected"
            @input="v => doRemove(item)"
          >
              {{ item[from] }}
          </v-chip>
        </template>
</v-combobox>
</v-flex>
</template>

<script>
import FieldMixin from '@/components/form/FieldMixin'

export default {
  mixins: [FieldMixin],
  data: () => ({
    search: null,
  }),
  computed: {
    selected: {
      get () { return this.fieldValue || [] },
      set (values) {
        this.fieldValue = values
      },
    },
    items () { return this.$store.getters[`${this.source}/unfiltered`] },
  },
  methods: {
    doRemove (toDelete) {
      this.fieldValue = this.fieldValue.filter(item => item.id !== toDelete.id)
    },

  },
}
</script>
